import React, { useCallback, useEffect, useState } from 'react';

import { EditAgentModal } from './EditAgentModal';
import { AndromedaAgentConfigurationTable } from './ConfigTable';
import { useAndromeda } from '../../../modules/Andromeda';
import { SignalRHubGroupListener } from '../../../components/SignalRHubGroupListener';

export const AgentConfigDashboard = () => {
  const {
    getAgents,
    signalRConfig: {
      hubUrl,
      hubName,
      hubGroups: { agentUpdates: hubGroup },
    },
  } = useAndromeda();

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedAgent, setSelectedAgent] = useState({});

  const listeners = [
    {
      name: hubGroup.listenerMethods.createAgent,
      method: (newAgent) => setData((agents) => [newAgent, ...agents]),
    },
    {
      name: hubGroup.listenerMethods.updateAgent,
      method: (agentUpdate) =>
        setData((agents) => [
          agentUpdate,
          ...agents.filter((x) => x.id !== agentUpdate.id),
        ]),
    },
    {
      name: hubGroup.listenerMethods.updateAgentCircuitBreaker,
      method: (newCircuitBreaker) => {
        setData((agents) => {
          const updatedAgent = {
            ...agents.find(
              (x) => x.circuitBreaker.operation === newCircuitBreaker.operation
            ),
            circuitBreaker: newCircuitBreaker,
          };
          return [
            updatedAgent,
            ...agents.filter((x) => x.id !== updatedAgent.id),
          ];
        });
      },
    },
  ];

  const closeEditModal = () => {
    setModalOpen(false);
    setSelectedAgent({});
  };

  const openEditModal = (agent) => {
    setSelectedAgent(agent);
    setModalOpen(true);
  };

  const fetchAgents = useCallback(async () => {
    setLoading(true);
    const agents = await getAgents();
    if (!!agents) setData(agents);
    setLoading(false);
  }, []);

  useEffect(() => {
    fetchAgents();
  }, [fetchAgents]);

  return (
    <>
      <SignalRHubGroupListener
        hubUrl={hubUrl}
        hubName={hubName}
        hubGroup={hubGroup}
        hubListeners={listeners}
      />
      <EditAgentModal
        agent={selectedAgent}
        open={modalOpen}
        handleClose={closeEditModal}
      />
      <AndromedaAgentConfigurationTable
        data={data}
        loading={loading}
        openEditModal={openEditModal}
      />
    </>
  );
};
